import { BaseSearchModel } from "../query/base-search.model";

export class PaymentSearchModel extends BaseSearchModel {
    sourceId?: string;
    invoiceId?: string;
}